import amplitude from 'amplitude-js';
// TODO : setup user id stuff
amplitude.getInstance().init('e1c44c746c373ab56c1c2ca96d92ec12', undefined, {
  includeReferrer: true,
  includeUtm: true,
});

export default amplitude.getInstance();
